import React, {FC, useState} from 'react';
import {Button} from "@mui/material";
import {CustomerText} from "./CustomerText";
import './style.css'
import {PartnerText} from "./PartnerText";
import {HowItWorksButtonGroup, HowItWorksH3, HowItWorksHeader, HowItWorksOverLine, HowItWorksSection} from "./styles";

const HowItWorks: FC = () => {
  const [showText, setShowText] = useState<boolean>(true);

  const showCustomerText = (): void => {
    setShowText(true);
  }

  const showPartnerText = (): void => {
    setShowText(false);
  }

  return <HowItWorksSection id='how-it-works'>
    <HowItWorksHeader>
      <HowItWorksH3 variant="h3" color="textPrimary">How SecurSpace Works?</HowItWorksH3>
      <HowItWorksOverLine variant="overline" color="textSecondary">HOW IT WORKS</HowItWorksOverLine>
    </HowItWorksHeader>
    <HowItWorksButtonGroup aria-label="outlined primary button group">
      <Button className='tab_btn' onClick={showCustomerText} variant={showText ? "contained" : "outlined"}
              color={showText ? "primary" : "secondary"}>For Buyers</Button>
      <Button className='tab_btn' onClick={showPartnerText} variant={!showText ? "contained" : "outlined"}
              color={!showText ? "primary" : "secondary"}>For Suppliers</Button>
    </HowItWorksButtonGroup>
    {showText ? <CustomerText /> : <PartnerText />}
  </HowItWorksSection>
}

export default HowItWorks;
